module.exports = __webpack_public_path__ + "img/asuransi-properti.b6a5ae7a.svg";